import React from 'react';
import { Badge, Box, Flex, Icon } from 'pounceV2';
import { ModalInputProps } from 'Components/fields/ModalInput/ModalInputV3';
import { useTheme } from '@mui/material';

export type ModalInputTriggerProps<T> = Pick<
  ModalInputProps<T>,
  'value' | 'invalid' | 'disabled' | 'label' | 'placeholder'
>;

function ModalInputTriggerV3<T>(
  props: ModalInputTriggerProps<T>,
): React.ReactElement<ModalInputTriggerProps<T>> {
  const {
    palette: { tokens },
  } = useTheme();
  const { value, invalid: isInvalid, disabled, label, placeholder } = props;
  const items = value as T[];

  const raised = !!placeholder || items?.length;
  return (
    <>
      <Box
        as="label"
        pointerEvents="none"
        fontSize="medium"
        px={4}
        color={isInvalid ? tokens.content.text.semantic.error.base : tokens.content.text.neutral[3]}
        top={0}
        left={0}
        position="absolute"
        transformOrigin="center left"
        transform={raised ? 'translate(6px, 4px) scale(0.65)' : 'translate(0, 14px) scale(1)'}
        transition="transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
        fontWeight={raised ? 'medium' : 'normal'}
      >
        {label}
      </Box>
      <Flex
        opacity={disabled ? 0.3 : 1}
        position="absolute"
        top={0}
        bottom={0}
        right={2}
        align="center"
        justify="center"
      >
        <Icon type="edit" size="medium" />
      </Flex>
      <Flex
        position="absolute"
        fontSize="medium"
        fontWeight="medium"
        left={0}
        px={4}
        align="center"
        justify="space-between"
        pr={8}
        width={1}
      >
        {items?.length ? (
          <>
            <Box truncated mr={2}>
              {items.join(',')}
            </Box>
            <Badge size="small" variant="info-subtle" borderStyle="rectangle" emphasized>
              {items.length}
            </Badge>
          </>
        ) : (
          placeholder
        )}
      </Flex>
    </>
  );
}

export default ModalInputTriggerV3;
